import React, { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useStoreState } from '@mortgage-pos/ui/store'

import LoanOfficerPopUp from '@mortgage-pos/ui/components/pricing/LoanOfficerPopUp'

export const useLoanOfficerPopUp = () => {
  const { active, isStart } = useStoreState((state) => state.questionnaire)
  const { loanOfficer } = useStoreState((state) => state.loanOfficer)

  const [wasExitToastShown, setWasExitToastShown] = useState(false)

  const ToastContent = React.createElement(LoanOfficerPopUp, {
    loanOfficer: loanOfficer,
  })

  const onMouseLeave = useCallback(
    (e) => {
      e.preventDefault()

      const ratesScreen = active?.name === 'pricing'

      if (
        loanOfficer &&
        !isStart &&
        e.clientY < 0 &&
        !wasExitToastShown &&
        !ratesScreen
      ) {
        toast(ToastContent)
        setWasExitToastShown(true)
      }
    },
    [loanOfficer, isStart, wasExitToastShown, active]
  )

  useEffect(() => {
    window.scrollTo(0, 0)

    if (loanOfficer && active?.name === 'pricing' && !wasExitToastShown) {
      toast(ToastContent, {
        delay: 120000,
      })
    }
  }, [active])

  useEffect(() => {
    document
      ?.getElementById('root')
      ?.addEventListener('mouseleave', onMouseLeave)

    return () => {
      document
        ?.getElementById('root')
        ?.removeEventListener('mouseleave', onMouseLeave)
    }
  }, [active, onMouseLeave])
}

export default useLoanOfficerPopUp
